import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import { CLIENT_SIGNUP, INVESTOR_SIGNUP, LOGIN } from 'app/constants/Routes';
import Banner from 'app/components/Banner';

import { resetForgotPasswordView } from 'app/actions/AuthedActions';
import { renderField } from 'app/utils/ReduxFormUtils';
import FooterLinks from 'app/components/FooterLinks';
import Alert from '../Alert';
import SideBar from '../SideBar';
import StyledLogin from './styled';
import Alerts from '../Extras/Alerts/index';
import queryString from 'qs';

const validate = (values) => {
    const errors = {};
    // eslint-disable-next-line
    const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!values.email) {
        errors.email = 'Required';
    }
    if (values.email && !re.test(values.email)) {
        errors.email = 'Invalid email';
    }
    return errors;
};


const ForgotPasswordFormComponent = (props) => {
    useEffect(() => {
        const { resetViewDispatch } = props;
        return () => resetViewDispatch();
    }, []);

    const { handleSubmit, submitting, resetPassword, resetError, userEmail, passwordInvalidated, location, passwordResetMessage } = props;
    const { set_password: setPassword } = location && location.search && queryString.parse(location.search, { ignoreQueryPrefix: true });
    const sentMsg = setPassword
        ? 'An email with instructions to set password has been sent to your email address, if it exists on our system.'
        : 'An email with password reset instructions has been sent to your email address, if it exists on our system.';

    return (
        <>
            {passwordInvalidated && (
                <div className="text-center">
                    <Alerts alertType="warning" content="Your Password has been expired,Please Reset it !" noBottomMarigin />
                </div>
            )}
            <StyledLogin>
                <div className="container">
                    <div className="row">
                        <div className="span6">
                            <SideBar />
                        </div>
                        <div className="span6">
                            <div className="login forgot">
                                <h4>{setPassword ? 'Setup A New Password' : passwordInvalidated ? 'Reset Your Password' : 'Forgot Password'}</h4>
                                <div>
                                    <form onSubmit={handleSubmit} autoComplete="off">
                                        <div className="form-group">
                                            <Field
                                                name="email"
                                                type="text"
                                                className="form-control"
                                                containerClassName="form-group"
                                                component={renderField}
                                                label="Enter your Email"
                                            />
                                            <i>@</i>
                                        </div>
                                        {(resetError !== null || resetPassword) && !passwordResetMessage && (
                                            <p className="text-center">
                                                <Alert type="info" msg={sentMsg} />
                                            </p>
                                        )}

                                        {passwordResetMessage && (
                                            <p className="text-center">
                                                <Alert type="danger" msg={passwordResetMessage} />
                                            </p>
                                        )}

                                        {userEmail && (
                                            <div className="text-center">
                                                <Alert
                                                    type="warning"
                                                    title="Link Expired!"
                                                    msg="Please reset your Password or Login if you remember it."
                                                    isHTML
                                                />
                                            </div>
                                        )}
                                        <ul className="actions">
                                            <li>
                                                <Link to={LOGIN}>Back To Login</Link>
                                            </li>
                                            <li>
                                                <button
                                                    className="btn blu-nw pull-right violet-nw"
                                                    disabled={submitting}
                                                    type="submit"
                                                    style={{ width: 'fit-content' }}
                                                >
                                                    {setPassword && submitting
                                                        ? 'Setting password...'
                                                        : setPassword
                                                        ? 'Set Password'
                                                        : submitting
                                                        ? 'Resetting...'
                                                        : 'Reset'}
                                                </button>
                                            </li>
                                        </ul>
                                        <p className="new-user">
                                            New User? <a href={CLIENT_SIGNUP}>Signup as a Borrower</a>
                                            <a href={INVESTOR_SIGNUP}>Signup as an Investor</a>
                                        </p>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="white-bg" />
                    <Banner />
                </div>
            </StyledLogin>
            <FooterLinks />
        </>
    );
};

const ForgotPasswordForm = reduxForm({
    form: 'forgotPassword',
    validate,
})(ForgotPasswordFormComponent);

const mapStateToProps = (state) => ({
    resetPassword: state.authed.resetPassword,
    userEmail: state.authed.userEmail,
    resetError: state.authed.resetError,
    passwordInvalidated: state.authed.passwordInvalidated,
    passwordResetMessage: state.authed.passwordResetMessage,
});

const mapDispatchToProps = (dispatch) => ({
    resetViewDispatch: () => dispatch(resetForgotPasswordView()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordForm);
